import { useCallback, useState } from 'react';
import { isNull } from 'utils';

export default function useCallbackRef<T = Record<string, any>>(init?: T) {
  const [ref, setRef] = useState<T | undefined>(init);

  const refCallback = useCallback((element: T) => {
    if (!isNull(element)) {
      setRef(element);
    }
  }, []);

  return [ref, refCallback] as [T, (element: T) => void];
}
